"use client";

import type { NavLink } from "@/components/landing/types";
import { useActiveSection } from "@/components/landing/hooks/useActiveSection";
import { LocaleSwitcher } from "@/components/LocaleSwitcher";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

interface HeaderProps {
	nav: NavLink[];
	loginLabel: string;
}

function Header(prop: HeaderProps) {
	const { nav, loginLabel } = prop;
	const { scrolled, active } = useActiveSection(nav);

	return (
		<header
			className={cn(
				"sticky top-0 z-40 transition-all duration-300",
				scrolled
					? "border-b border-border bg-bg/80 backdrop-blur-md"
					: "border-b border-transparent",
			)}
		>
			<div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-6">
				<Link href="/" className="shrink-0">
					<Logo className="h-9 w-auto text-foreground" />
				</Link>

				<nav className="hidden items-center gap-7 text-sm font-medium text-muted-foreground md:flex">
					{nav.map((n) => (
						<a
							key={n.href}
							href={n.href}
							className={cn(
								"transition-colors hover:text-text",
								active === n.href ? "text-text" : "",
							)}
							aria-current={active === n.href ? "true" : undefined}
						>
							{n.label}
						</a>
					))}
				</nav>

				<div className="flex items-center gap-2">
					<LocaleSwitcher />
					<ThemeToggle />
					<Link href="/admin" className="btn btn-primary text-sm">
						{loginLabel}
					</Link>
				</div>
			</div>
		</header>
	);
}

export default Header;
